import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
import React from "react";
import { useSelector } from "react-redux";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
import styles from "./styles.module.scss";
const MissHeader = ({ handleReactivate }) => {
    const user = useSelector((state) => state.user);
    const head = user.is_influencer
        ? "Welcome"
        : user.cancelled_less_two_days
            ? "We’re sorry to see you go!"
            : "We’ve Missed You!";
    const btnLabel = user.is_influencer ? "Add Payment" : "reactivate subscription";
    const subHead = user.is_influencer
        ? "To activate your subscription, add your payment and reactivate in the subscription tab. "
        : user.cancelled_less_two_days
            ? "Your subscription has been cancelled. Come back any time to reactivate Gainful."
            : "Your subscription has been cancelled. Come back today to get the most out of Gainful.";
    return (_jsx("div", { className: styles.container, children: _jsxs("div", { className: styles.content, children: [_jsxs("div", { className: styles.left, children: [_jsx("span", { className: styles.head, children: head }), _jsx("span", { className: styles.subHead, children: subHead })] }), _jsx(RoundedGainfulButton, { extraClassName: styles.btn, label: btnLabel.toUpperCase(), onClick: () => handleReactivate(), dataAttr: "reactivate-subscription-button" })] }) }));
};
export default MissHeader;
